export default __webpack_public_path__ + "static/media/header-background.13a73d53.webp";